import { render, staticRenderFns } from "./ElementId.vue?vue&type=template&id=3a089f34&"
import script from "./ElementId.vue?vue&type=script&lang=js&"
export * from "./ElementId.vue?vue&type=script&lang=js&"
import style0 from "./ElementId.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports